"use client";

import { Card, Typography } from "antd";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { NEXT_PARAM } from "@/lib/redirect";
import LoginButton from "./LoginButton";

const { Title, Text } = Typography;

const errorMessages: Record<string, string> = {
  AccessDenied: "Your account is not authorized to access this app.",
  OAuthCallbackError: "Sign-in failed. Please try again.",
};

function LoginCard() {
  const searchParams = useSearchParams();
  const error = searchParams.get("error");
  const next = searchParams.get(NEXT_PARAM);

  return (
    <Card className="w-[380px]">
      <div className="text-center mb-6">
        <Title level={3} className="m-0">
          Appo CRM
        </Title>
        <Text type="secondary">Sign in with your company account</Text>
      </div>

      {error && (
        <div className="mb-4">
          <Text type="danger">
            {errorMessages[error] ?? "An unexpected error occurred."}
          </Text>
        </div>
      )}

      <LoginButton next={next} />
    </Card>
  );
}

export default function LoginPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-[#f0f2f5]">
      <Suspense>
        <LoginCard />
      </Suspense>
    </div>
  );
}
